"use strict";

var SynoApp = SynoApp || {};

(function ($) {
  "use strict";

  SynoApp.WidgetModel = Backbone.Model.extend({
    defaults: {
      title_content: 'New Widget',
      title_display: 'block',
      title_size: 24,
      title_style: 'normal',
      title_align: 'center',
      title_color: '#656565',
      title_background: '#FFFFFF',
      title_line_height: '1.2',
      panel_border_size: 1,
      panel_border_style: 'solid',
      panel_border_color: '#E3E8ED',
      panel_border_radius: 0,
      icon_content: '',
      icon_scale: 90,
      icon_display: 'block',
      icon_path: '',
      value_aggregation: 'latest',
      value_hours: 1,
      value_display: 'block',
      value_size: 48,
      value_style: 'normal',
      value_align: 'center',
      value_color: '#656565',
      freshness_display: 'none',
      freshness_size: 12,
      freshness_style: 'normal',
      freshness_align: 'center',
      freshness_color: '#656565',
      chart_display: 'none',
      chart_width: '6',
      chart_hours: '12',
      chart_val_type: 'line',
      chart_val_color: '#3d85c6',
      chart_val_size: 2,
      chart_val_pointer: 'true',
      chart_acc_type: 'none',
      chart_acc_color: '#e69138',
      chart_acc_size: 1,
      chart_acc_pointer: 'false',
      chart_threshold_display: 'none',
      chart_threshold_size: '1',
      chart_auto: 'true',
      chart_min: 0,
      chart_max: 100,
      x: 0,
      y: 0,
      width: 4,
      height: 6,
      station_id: 0,
      measure_id: 0
    },
    data: {
      value: '---',
      freshness: '',
      val_series: [],
      acc_series: [],
      dates: [],
      threshold: [],
      measure_decimal_out: 1,
      now: null,
      status: ''
    },
    initialize: function initialize() {
      this.default_data = this.data;
    }
  });
  SynoApp.DefaultWidgetModel = Backbone.Model.extend({
    defaults: new SynoApp.WidgetModel().attributes
  });
  SynoApp.SynoCollection = Backbone.Collection.extend({
    model: SynoApp.WidgetModel,
    interval: null,
    loader_showed: false,
    initialize: function initialize(models, options) {
      this.id = options.id;
    },
    startPolling: function startPolling() {
      var self = this;
      self.fetchData();
      self.interval = setInterval(function () {
        self.fetchData();
      }, 30 * 1000);
    },
    // stopPolling: function(){
    //     clearInterval(this.interval);
    // },
    fetchData: function fetchData(cid) {
      var self = this;
      var models_configured = this.filter(function (model) {
        return typeof cid === 'undefined' || cid === model.cid;
      });
      var models_config = models_configured.map(function (model) {
        return {
          cid: model.cid,
          station_id: model.get('station_id'),
          measure_id: model.get('measure_id'),
          value_aggregation: model.get('value_aggregation'),
          value_hours: model.get('value_hours'),
          chart_display: model.get('chart_display'),
          chart_hours: model.get('chart_hours')
        };
      });

      if (!models_config.length) {
        return;
      }

      $.ajax({
        url: SynoApp.urls.data,
        data: {
          json: JSON.stringify(models_config)
        },
        method: 'POST',
        success: function success(json) {
          _APP.utilities.hideLoader();

          self.loader_showed = false;

          _.each(models_config, function (model_config) {
            var widget = self.get(model_config.cid);
            var old_data = JSON.parse(JSON.stringify(widget.data));

            if (json.hasOwnProperty(model_config.cid)) {
              widget.data = json[model_config.cid];
            } else {
              widget.data = widget.default_data;
            }

            var new_data = JSON.parse(JSON.stringify(widget.data));
            delete old_data.now;
            delete new_data.now;

            if (JSON.stringify(old_data) !== JSON.stringify(new_data) || widget.get('icon_path') !== '') {
              widget.trigger('change', widget, {});
            }
          });
        },
        error: function error(xhr, status, _error) {
          if (xhr.status == 403) {
            $('#loginModal').modal('show');
          }

          if (self.loader_showed === false) {
            _APP.utilities.showLoader();

            self.loader_showed = true;
          }
        }
      });
    }
  });
  SynoApp.ConfigView = Backbone.View.extend({
    tagName: 'div',
    template: _.template($('#config-template').html()),
    measuresTemplate: _.template($('#measures-template').html()),
    events: {
      'keyup input, select': 'update_model',
      'change input, select': 'update_model',
      'click #apply_to_existing': 'apply_to_existing'
    },
    initialize: function initialize() {
      this.listenTo(this.model, 'destroy', this.remove);
    },
    update_model: function update_model(e) {
      this.model.set(e.target.id, e.target.value);

      if (e.target.id === 'station_id') {
        this.renderMeasures();
      }

      if (e.target.id === 'icon_content') {
        if (e.target.value === 'custom') {
          this.$el.find('#icon_path').parents('.form-group').slideDown(150);
        } else {
          this.$el.find('#icon_path').parents('.form-group').slideUp(150);
        }
      }

      if (e.target.id === 'value_aggregation') {
        if (e.target.value !== 'latest') {
          this.$el.find('#value_hours').parent().show();
        } else {
          this.$el.find('#value_hours').parent().hide();
        }
      }

      if (e.target.id === 'chart_display') {
        if (e.target.value !== 'none') {
          this.$el.find('#chart_width').parent().show();
        } else {
          this.$el.find('#chart_width').parent().hide();
        }
      }

      if (e.target.id === 'chart_auto') {
        if (e.target.value === 'false') {
          this.$el.find('#chart_min').parent().show();
          this.$el.find('#chart_max').parent().show();
        } else {
          this.$el.find('#chart_min').parent().hide();
          this.$el.find('#chart_max').parent().hide();
        }
      }
    },
    apply_to_existing: function apply_to_existing() {
      var json = this.model.toJSON();
      delete json.x;
      delete json.y;
      delete json.width;
      delete json.height;
      SynoApp.syno.each(function (widget) {
        widget.set(json);
      });
    },
    render: function render() {
      var json = this.model.toJSON();
      json.is_default_widget = this.model instanceof SynoApp.DefaultWidgetModel;
      this.$el.html(this.template(json));
      this.$el.dialog({
        title: SynoApp.translations.configuration,
        width: $(window).width() > 678 ? 678 : 'auto',
        resizable: false
      });
      this.$el.find('#tabs').tabs();
      this.$el.find('.select2').each(function () {
        $(this).select2({
          width: '100%',
          minimumResultsForSearch: 10
        });
      });
      $('.colorpicker').spectrum();
      return this;
    },
    renderMeasures: function renderMeasures() {
      var self = this;

      if (self.model.get('station_id')) {
        _APP.utilities.showLoader();

        $.ajax({
          url: SynoApp.urls.measures + '/' + self.model.get('station_id'),
          success: function success(json) {
            var measures = [];

            if (json.hasOwnProperty('ConfigurationMeasuress')) {
              measures = json.ConfigurationMeasuress;
            }

            var data = {
              measures: measures,
              old_measure_id: self.model.get('measure_id')
            };
            self.$el.find('#measure_id').html(self.measuresTemplate(data)).trigger('change');

            _APP.utilities.hideLoader();
          },
          error: function error() {
            var data = {
              measures: [],
              old_measure_id: self.model.get('measure_id')
            };
            self.$el.find('#measure_id').html(self.measuresTemplate(data)).trigger('change');

            _APP.utilities.hideLoader();
          },
          dataType: 'json'
        });
      }
    }
  });
  SynoApp.WidgetView = Backbone.View.extend({
    tagName: 'div',
    template: _.template($('#panel-template').html()),
    chart: null,
    events: {
      'click .widget__remove': 'clear',
      'click .widget__config': 'config',
      'click .widget__clone': 'clone',
      'dblclick .widget': 'config'
    },
    id: function id() {
      return this.model.cid;
    },
    className: function className() {
      return 'grid-stack-item';
    },
    initialize: function initialize() {
      this.listenTo(this.model, 'change:station_id', this.fetchData);
      this.listenTo(this.model, 'change:measure_id', this.fetchData);
      this.listenTo(this.model, 'change:value_aggregation', this.fetchData);
      this.listenTo(this.model, 'change:value_hours', this.fetchData);
      this.listenTo(this.model, 'change:chart_display', this.fetchData);
      this.listenTo(this.model, 'change:chart_hours', this.fetchData);
      this.listenTo(this.model, 'change:chart_threshold', this.fetchData);
      this.listenTo(this.model, 'change', this.render);
      this.listenTo(this.model, 'destroy', this.remove);
      this.listenTo(this.model, 'chart', this.plot);
    },
    render: function render() {
      var json = this.model.toJSON();
      json.data = this.model.data;
      json.time_version = Math.floor(new Date().getTime() / 120 / 1000).toString();
      this.$el.find('.grid-stack-item-content').remove();
      this.$el.prepend(this.template(json));
      this.plot();
      return this;
    },
    plot: function plot() {
      var self = this;
      var options = {
        chart: {
          height: Math.round(Math.max(self.$el.find('.widget__chart').height(), 1)) + 'px',
          animation: false,
          zoomType: 'xy'
        },
        exporting: {
          enabled: false
        },
        title: {
          text: ''
        },
        legend: {
          enabled: false
        },
        credits: {
          enabled: false
        },
        plotOptions: {
          series: {
            animation: false
          },
          column: {
            minPointLength: 3
          }
        },
        tooltip: {
          dateTimeLabelFormats: {
            millisecond: "%Y-%m-%d %H:%M",
            second: "%Y-%m-%d %H:%M",
            minute: "%Y-%m-%d %H:%M",
            hour: "%Y-%m-%d, %H:%M",
            day: "%Y-%m-%d",
            week: "%Y-%m-%d",
            month: "%Y-%m",
            year: "%Y"
          }
        },
        xAxis: {
          type: 'datetime',
          max: self.model.data.timestamp,
          gridLineWidth: 1,
          lineWidth: 1,
          crosshair: true,
          tickPixelInterval: 12,
          labels: {
            rotation: -45
          },
          dateTimeLabelFormats: {
            millisecond: '%H:%M',
            second: '%H:%M',
            minute: '%H:%M',
            hour: '%H:%M',
            day: '%Y-%m-%d',
            week: '%Y-%m-%d',
            month: '%Y-%m-%d',
            year: '%Y-%m-%d'
          }
        },
        yAxis: {
          title: {
            'text': ''
          },
          labels: {
            format: '{value:.' + self.model.data.measure_decimal_out + 'f}'
          },
          minTickInterval: 1 / Math.pow(10, self.model.data.measure_decimal_out),
          tickPixelInterval: 12,
          // lineWidth: 1,
          min: self.model.get('chart_auto') === 'false' ? parseFloat(self.model.get('chart_min')) : null,
          max: self.model.get('chart_auto') === 'false' ? parseFloat(self.model.get('chart_max')) : null,
          plotLines: []
        },
        series: []
      };

      _.each(['acc', 'val'], function (series_name) {
        var type, step;

        if (self.model.get('chart_' + series_name + '_type') !== 'none') {
          type = 'line';
          step = self.model.get('chart_' + series_name + '_type') === 'stairs';

          if (self.model.get('chart_' + series_name + '_type') === 'bar') {
            type = 'column';
          }

          options.series.push({
            name: series_name.toUpperCase(),
            type: type,
            step: step,
            data: self.model.data[series_name + '_series'],
            lineWidth: parseInt(self.model.get('chart_' + series_name + '_size')),
            pointWidth: parseInt(self.model.get('chart_' + series_name + '_size')) * 2,
            color: self.model.get('chart_' + series_name + '_color'),
            marker: {
              enabled: self.model.get('chart_' + series_name + '_pointer') === 'true',
              radius: parseInt(self.model.get('chart_' + series_name + '_size')) + 1.5,
              symbol: 'circle'
            },
            tooltip: {
              pointFormat: '{series.name}: {point.y:.' + self.model.data.measure_decimal_out + 'f}'
            }
          });
        }
      });

      if (self.model.get('chart_threshold_display') === 'line') {
        var threshold_colors = {
          alarm_max: '#F41807',
          alarm_min: '#F41807',
          pre_max: '#F57509',
          pre_min: '#F57509',
          warn_max: '#EFC30A',
          warn_min: '#EFC30A'
        };
        var dummy_data = [];

        _.each(self.model.data.threshold, function (value, name) {
          if (value !== '') {
            value = parseFloat(value);
            options.yAxis.plotLines.push({
              value: value,
              color: threshold_colors[name],
              width: parseInt(self.model.get('chart_threshold_size')),
              zIndex: 3
            });
            dummy_data.push([self.model.data.timestamp, value]);
          }
        }); //DUMMY SERIES FOR AUTOSCALE AND SHOW PLOTLINES WITH THRESHOLD


        options.series.push({
          type: 'scatter',
          name: 'Thresholds',
          data: dummy_data,
          enableMouseTracking: false,
          marker: {
            enabled: false
          }
        });
      }

      self.chart = self.$el.find('.widget__highcharts').highcharts(options);
    },
    clear: function clear() {
      $('.grid-stack').data('gridstack').removeWidget(this.$el);
      this.model.destroy();
    },
    config: function config() {
      if (SynoApp.synoView.attributes.editable) {
        if (typeof SynoApp.configView !== 'undefined') {
          SynoApp.configView.remove();
        }

        SynoApp.configView = new SynoApp.ConfigView({
          model: this.model
        });
        SynoApp.configView.render();
        SynoApp.configView.renderMeasures();
      }
    },
    clone: function clone() {
      var json = this.model.toJSON();
      json.title_content = json.title_content + ' - ' + SynoApp.translations.copy;
      var cloned = new SynoApp.WidgetModel(json);
      this.model.collection.add(cloned);
      this.model.collection.fetchData(cloned.cid);
    },
    fetchData: function fetchData() {
      this.model.collection.fetchData(this.model.cid);
    }
  });
  SynoApp.SynoView = Backbone.View.extend({
    el: '#synoApp',
    grid: null,
    gridTag: '.grid-stack',
    widgetsTag: '[name="widgets"]',
    defaultTag: '[name="default"]',
    events: {
      'click .new-widget': 'addOne',
      'click .general-config': 'generalConfig',
      'click .save': 'save',
      'dragstop .grid-stack': 'updatePosition',
      'gsresizestop .grid-stack': 'updateDimension',
      // 'added .grid-stack': 'chart',
      'submit form': 'save'
    },
    initialize: function initialize() {
      $(this.gridTag).gridstack({
        cellHeight: 40,
        //default 80
        verticalMargin: 10,
        //default 20
        float: true,
        //default false
        // animate: true, //default false
        disableOneColumnMode: !this.attributes.responsive,
        resizable: {
          handles: 'e, se, s, sw, w'
        }
      });
      this.grid = this.$el.find(this.gridTag).data('gridstack'); //reset add remove change

      this.listenTo(this.collection, 'reset', this.render, this);
      this.listenTo(this.collection, 'add', this.renderOne, this);
      this.render();

      if (this.attributes.editable) {
        $(window).bind('beforeunload', this.beforeunloadHandler);
      }
    },
    render: function render() {
      var self = this;
      $(this.grid).html('');
      this.collection.each(function (widget) {
        var view = new SynoApp.WidgetView({
          model: widget
        });
        self.grid.addWidget(view.render().$el, widget.get('x'), widget.get('y'), widget.get('width'), widget.get('height'));
      });
      this.collection.startPolling();

      if (this.attributes.editable) {
        this.enableEdit();
      } else {
        this.disableEdit();
      }
    },
    renderOne: function renderOne(widget) {
      var view = new SynoApp.WidgetView({
        model: widget
      });
      this.grid.addWidget(view.render().$el, widget.get('x'), widget.get('y'), widget.get('width'), widget.get('height'), true);
      var node = view.$el.data('_gridstack_node');
      widget.set('x', node.x, {
        silent: true
      });
      widget.set('y', node.y, {
        silent: true
      });
      widget.set('width', node.width, {
        silent: true
      });
      widget.set('height', node.height, {
        silent: true
      });

      if (this.attributes.editable) {
        this.enableEdit();
      } else {
        this.disableEdit();
      }

      view.config();
    },
    addOne: function addOne() {
      var newWidget = new SynoApp.WidgetModel(SynoApp.defaultWidget.attributes);
      this.collection.add(newWidget);
      this.collection.fetchData(newWidget.cid);
    },
    generalConfig: function generalConfig() {
      if (SynoApp.synoView.attributes.editable) {
        if (typeof SynoApp.configView !== 'undefined') {
          SynoApp.configView.remove();
        }

        SynoApp.configView = new SynoApp.ConfigView({
          model: SynoApp.defaultWidget
        });
        SynoApp.configView.render();
        SynoApp.configView.renderMeasures();
      }
    },
    updatePosition: function updatePosition(event) {
      var el = $(event.target);
      var node = $(el).data('_gridstack_node');
      var widget = this.collection.get($(el).attr('id'));
      widget.set('x', node.x, {
        silent: true
      });
      widget.set('y', node.y, {
        silent: true
      });
      widget.set('width', node.width, {
        silent: true
      });
      widget.set('height', node.height, {
        silent: true
      });
      widget.trigger('chart', widget, {});
    },
    updateDimension: function updateDimension(event, el) {
      // var el = $(event.target);
      var node = $(el).data('_gridstack_node');
      var widget = this.collection.get($(el).attr('id'));
      widget.set('x', node.x, {
        silent: true
      });
      widget.set('y', node.y, {
        silent: true
      });
      widget.set('width', node.width, {
        silent: true
      });
      widget.set('height', node.height, {
        silent: true
      });
      widget.trigger('chart', widget, {});
    },
    // chart: function(event, items){
    //     var self = this;
    //     _.each(items, function(item){
    //         var el = $(item.el);
    //         var widget = self.collection.get(el.attr('id'));
    //         widget.trigger('chart', widget, {});
    //     });
    // },
    disableEdit: function disableEdit() {
      this.grid.disable();
      this.$el.find('.grid-stack').removeClass('editable');
    },
    enableEdit: function enableEdit() {
      this.grid.enable();
      this.$el.find('.grid-stack').addClass('editable');
    },
    save: function save() {
      $(window).unbind('beforeunload', this.beforeunloadHandler);
      $(this.widgetsTag).val(encodeURI(JSON.stringify(this.collection.toJSON())));
      $(this.defaultTag).val(encodeURI(JSON.stringify(SynoApp.defaultWidget.toJSON())));
    },
    beforeunloadHandler: function beforeunloadHandler() {
      return SynoApp.translations.leave;
    }
  });
})(jQuery);